import { isJust, Maybe as StructuredMaybe } from '@execonline-inc/structured-maybe';
import { Maybe, nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import Modal from '../../../../Modal';
import { shareStore } from '../Stores/ShareStore';
import { ShareBy, ShareType } from '../Stores/ShareStore/Types';
import Content from './Content';
import Title from './Title';

interface Props {
  close: () => void;
  collectionId: number;
  publishedAt: StructuredMaybe<Date>;
  onPublishSuccess?: (publishedAt: StructuredMaybe<Date>) => void;
  returnPath?: string;
}

const ShareOptionsModal: React.FC<Props> = ({
  close,
  collectionId,
  publishedAt,
  onPublishSuccess,
  returnPath,
}) => {
  const [shareBy, setShareBy] = React.useState<ShareBy>('email');
  const [shareType, setShareType] = React.useState<ShareType>('collection');
  const [selectedProgramFamilyId, setSelectedProgramFamilyId] =
    React.useState<Maybe<number>>(nothing());
  // Load the shareStore when modal opens
  React.useEffect(() => {
    shareStore.load(collectionId, shareBy, shareType, nothing());
  }, [collectionId, shareBy, shareType]);

  // Use shareStore's built-in togglePublishAndReload which handles both the toggle and reload
  const handleTogglePublished = () => {
    const shouldPublish = !isJust(publishedAt);
    shareStore.togglePublishAndReload(shouldPublish, onPublishSuccess);
  };

  // Check if currently publishing - use shareStore state
  const isCurrentlyPublishing = shareStore.state.kind === 'publishing';

  return (
    <Modal
      close={close}
      contentPadding="px-1"
      title={<Title />}
      modalWidth="w-[600px] max-w-[600px] overflow-hidden"
      disableBodyScroll
    >
      <div className="pt-6">
        <Content
          collectionId={collectionId}
          shareBy={shareBy}
          setShareBy={setShareBy}
          shareType={shareType}
          setShareType={setShareType}
          selectedProgramFamilyId={selectedProgramFamilyId}
          setSelectedProgramFamilyId={setSelectedProgramFamilyId}
          close={close}
          publishedAt={publishedAt}
          onTogglePublished={handleTogglePublished}
          isPublishing={isCurrentlyPublishing}
          returnPath={returnPath}
        />
      </div>
    </Modal>
  );
};

export default observer(ShareOptionsModal);
